// @flow

import React from "react";
import "./CarElement.scss";
import type FilterVehicleModel from "../../models/FilterVehicleModel";

export type CarElementProps = {
    imgSrc: string,
    name: string,
    title: string,
    id: string,
    setVehicle: (string, string) => void,
    selected: boolean,
    vehicleModels: FilterVehicleModel[],
    toggleVehicleSelector: string => void,
    visibleVehicleModel: string,
    carRef: ?HTMLElement,
    allowsClick: boolean,
}

const CarElement = (props: CarElementProps) => {
    const handleCarClick = () => {
        if (!props.allowsClick) return;
        const vehicleModels = props.vehicleModels || [];
        const hasDeeperOptions = vehicleModels.some(model => (
            model && Array.isArray(model.categories) && model.categories.length > 0
        ));
        if (vehicleModels.length <= 1 && !hasDeeperOptions) {
            props.setVehicle(props.name, null);
            return;
        }
        props.toggleVehicleSelector(props.visibleVehicleModel !== props.name ? props.name : "");
    };

    const handleKeyDown = (e: SyntheticKeyboardEvent<HTMLElement>) => {
        if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            handleCarClick();
        }
    };

    return (
        <button
            className={"hpm-carElement"}
            type={"button"}
            onClick={handleCarClick}
            onKeyDown={handleKeyDown}
            tabIndex={0}
            aria-label={`${props.title} ${props.name}`}
            ref={props.carRef}>
            <img role={"presentation"} alt={""} src={props.imgSrc}/>
            <div className={"hpm-carSeries"}>{props.title}</div>
        </button>
    );
};

export default CarElement;
